import React from "react"
import PropTypes from "prop-types"

import Typograph from "../../../../components/Typograph"

import styles from "./styles.css"

const DescriptionList = ({ description, value }) => {
  return (
    <dl className={styles.containerClass}>
      <dt>
        <Typograph
          htmlTag="h2"
          size="medium"
          color="outer_space"
          weight="regular"
        >
          {description}
        </Typograph>
      </dt>
      <dd>
        <Typograph htmlTag="p" size="medium" color="outer_space" weight="bold">
          {value}
        </Typograph>
      </dd>
    </dl>
  )
}

DescriptionList.propTypes = {
  description: PropTypes.string,
  value: PropTypes.string
}
export default DescriptionList



// WEBPACK FOOTER //
// ./src/scenes/NewInterfaceOnline/components/DescriptionList/index.js